import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { Globals } from './shared/globals/globals';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(private globals: Globals) {
		this.globals = globals;
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add auth header with jwt if account is logged in and request is to the api url
		const isApiUrl = req.url.startsWith(environment.backend_Jab_url);
		const userLanguage = this.globals.user?.language || 'en-us';
		let headers = req.headers.set('Accept-Language', userLanguage);
        if (isApiUrl && this.globals.user && localStorage['wingsEncodedAccessToken']) {
            if(req.url.startsWith('http://localhost:11000/WingsREST/')) {
				headers = headers.set('Authorization', `Basic ${btoa(this.globals.user.userName+":"+this.globals.user.userName)}`)
            } else {
				headers = headers.set('Authorization', `Bearer ${localStorage['wingsEncodedAccessToken']}`)
			}
		}

		req = req.clone({ headers });
		return next.handle(req);
	}
}
